module.exports = __webpack_public_path__ + "static/desktop/img/photobook-5.55c69e61.png";